import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

const wait = (ms: number) => new Promise<void>((resolve) => window.setTimeout(resolve, ms));

const withTimeout = async <T,>(promise: Promise<T>, timeoutMs: number, errorMessage: string): Promise<T> =>
  Promise.race([
    promise,
    new Promise<never>((_, reject) => window.setTimeout(() => reject(new Error(errorMessage)), timeoutMs)),
  ]);

const SyncSubscriptionPage: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const [message, setMessage] = useState('Sincronizando assinatura e atualizando seu acesso...');
  const hasStartedSync = useRef(false);

  useEffect(() => {
    if (hasStartedSync.current) return;
    hasStartedSync.current = true;

    let isMounted = true;
    let redirectTimeout: number | null = null;

    const syncSubscription = async () => {
      try {
        // Aguarda no maximo 5s o estado inicial do auth terminar.
        const authLoadingStart = Date.now();
        while (auth.isLoading && Date.now() - authLoadingStart < 5000) {
          await wait(150);
        }

        await withTimeout(
          auth.signinSilent(),
          8000,
          'Tempo limite excedido na sincronizacao silenciosa da sessao.'
        );
        if (!isMounted) return;
        setMessage('Assinatura sincronizada com sucesso. Redirecionando...');
        redirectTimeout = window.setTimeout(() => navigate('/assinatura', { replace: true }), 900);
      } catch (error) {
        console.error('Erro ao sincronizar grupos do usuario apos retorno do Stripe:', error);
        if (!isMounted) return;
        setMessage('Nao foi possivel sincronizar automaticamente. Voce pode tentar novamente em instantes.');
        redirectTimeout = window.setTimeout(() => navigate('/assinatura', { replace: true }), 1800);
      }
    };

    syncSubscription();

    return () => {
      isMounted = false;
      if (redirectTimeout) {
        window.clearTimeout(redirectTimeout);
      }
    };
  }, [auth, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen-1/2 gap-4 p-4">
      <div className="w-12 h-12 border-4 border-gray-200 border-t-blue-700 rounded-full animate-spin"></div>
      <p className="text-center text-gray-700">{message}</p>
    </div>
  );
};

export default SyncSubscriptionPage;
